import {
  useState,
} from 'react';

import {
  toast,
} from 'react-toastify';

import * as S from './styled';

type Props = {
  src: string,
  preview: string,
};

const Video = ({ src, preview }: Props) => {
  const [isPlaying, setPlay] = useState<boolean>(false);
  return (
    <S.Video>
      {isPlaying ? (
        <S.Frame
          src={`${src}?autoplay=1`}
          allowFullScreen
        />
      ) : (
        <S.Preview
          style={preview
            ? { backgroundImage: `url(${preview})` }
            : {}}
        >
          <S.PlayIcon onClick={() => (src ? setPlay(true) : toast.error('Error.'))}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              width={15}
              height={15}
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="primary-color"
            >
              <path d="M12 6v6l4 2" />
              <circle cx="12" cy="12" r="10" />
            </svg>
          </S.PlayIcon>
        </S.Preview>
      )}
    </S.Video>
  );
};

export default Video;
